"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const setting_item_1 = require("./setting-item");
const user_info_layout_1 = require("./user-info-layout");
const user_context_1 = require("../../../context/user-context");
const token_1 = require("../../../storage/token");
const button_1 = require("../../../component/input/button");
const log_1 = require("../../../model/log");
exports.LeftPanel = (0, react_1.memo)(({ profileType, onProfileTypeChange }) => {
    const theme = (0, material_1.useTheme)();
    const { refresh: refreshUserMeta } = (0, user_context_1.useUserUpdate)();
    const handleLogout = (0, react_1.useCallback)(() => {
        (0, token_1.removeToken)();
        refreshUserMeta();
    }, [refreshUserMeta]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", width: "25%", minWidth: theme.spacing(40), sx: {
            backgroundColor: theme.palette.primary.main,
            boxShadow: theme.shadows[2],
        }, spacing: 4, paddingY: 4, children: [(0, jsx_runtime_1.jsx)(user_info_layout_1.UserInfoLayout, {}), (0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "column", children: Object.values(setting_item_1.SettingConfigurationType).map((type) => ((0, jsx_runtime_1.jsx)(setting_item_1.SettingItem, { type: type, isSelected: profileType === type, onClick: () => onProfileTypeChange(type) }, type))) }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    flex: 1,
                }, minHeight: theme.spacing(10) }), (0, jsx_runtime_1.jsx)(button_1.Button, { size: "large", onClick: handleLogout, sx: {
                    width: theme.spacing(20),
                    alignSelf: "center",
                    color: theme.palette.primary.contrastText,
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.3)",
                    },
                    borderRadius: theme.spacing(2),
                }, eventName: log_1.LogEventClickName.SignOut, children: "Logout" })] }));
});
exports.LeftPanel.displayName = "UserProfilePanel";
